<template>
  <v-card class="elevation-12 mt-3 mx-1">
    <v-toolbar color="primary" dark flat>
      {{ pageTitle }}
    </v-toolbar>

    <template v-if="isMailLoaded">
      <v-card-text>
        <div class="d-flex">
          <v-btn v-if="isAllowSawPdf" color="warning" class="mt-1" @click="onReprintButtonClicked">Распечатать</v-btn>
          <v-btn color="primary" class="ml-1 mt-1" v-if="mail.isPrinted"
                 :to="{name: 'print-package', params: {uid: mail.printPackage.uid}}">Печатный реестр:
            {{ mail.printPackage.uid }}
          </v-btn>
          <v-btn color="primary" class="ml-1 mt-1" v-if="mail.isPacked"
                 :to="{name: 'post-package', params: {uid: mail.postPackage.uid}}">Пост-пакет: {{
              mail.postPackage.uid
            }}
          </v-btn>
          <v-btn v-if="isAllowUpdateStatusPerform" color="green ml-2" style="color: white" class="mt-1" @click="updateStatus()">Обновить статус (Статусни янгилаш)</v-btn>

          <v-spacer/>
          <h2>
            Статус:
            <template v-if="mail.isPerformed">
              {{ mail.perform.performType.name }}
            </template>
            <template v-else>
              Неустановлен
            </template>

            <template v-if="mail.postPackage && mail.postPackage.postCode">
              <br/>
              в {{ mail.postPackage.postCode }}
            </template>
          </h2>
        </div>
      </v-card-text>

      <v-card-text class="py-0">
        <v-row>
          <v-col cols="12" md="3"></v-col>
          <v-col cols="12" md="9" class="text-right">
            <PerformButtons :mail="mail"
                            :mail-history="histories"
                            :delete-perform-dialog="deletePerformDialog"
                            :unset-post-package-dialog="unsetPostPackageDialog"
                            :try-perform-dialog="tryPerformDialog"
                            :delivered-dialog="deliveredDialog"
                            :failed-dialog="failedDialog"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text class="py-0">
        <v-row>
          <v-col cols="12" md="12">
            <p class="heading" v-for="history in histories" :key="history.id">
              <b>{{ history.createdOn.format("DD.MM.YYYY HH:mm:ss") }}</b>
              <b class="ml-2 green--text darken-4" v-if="!!history.account">
                {{ history.account.name }}
              </b>
              <b>
                {{ history.type.name }}
                <span v-if="history.perform && history.type !== isRemovedFromPostPackage">
                  <span class="blue--text">{{ history.perform.performType.name }}</span>
                  <span>
                    | Дата результата: <span class="blue--text">{{ history.perform.performedOn.format("DD.MM.YYYY") }} </span>
                  </span>
                  <span v-if="history.perform.notifiedOn">
                    | Дата информирования: <span class="blue--text">{{ formatDate(convertDateStringToDateTime(history.perform.notifiedOn)) }}</span>
                  </span>
                </span>
                <template v-if="history.transfer && history.type !== isRemovedFromPostPackage">
                  <span class="blue--text">| Номер заказа: {{ history.transfer.clientOrderId }}</span>
                </template>
                <template v-if="history.postPackageUid && history.type !== isRemovedFromPostPackage">
                  <span class="blue--text">
                          {{ history.postPackageUid }}
                  </span>
                  <span v-if="history.postPackagePostCode" class="ml-5">
                        Индекс пост пакета: {{ history.postPackagePostCode }}
                   </span>
                  <span v-if="mail.postPackage" class="ml-5">
                        Дата пост пакета: {{ new Date(mail.postPackage.createdOn).toLocaleString('ru-RU') }}
                   </span>
                </template>
                <span v-if="history.printPackageUid" class="blue--text">
                  {{ history.printPackageUid }}
                </span>
                <template v-if="history.type === isRemovedFromPostPackage">
                  <span v-if="getMailPostCode()" class="ml-5">
                    Индекс: {{ getMailPostCode() }}
                   </span>
                </template>
                <span v-if="history.postIndex && history.type !== isRemovedFromPostPackage" class="yellow">
                  {{ history.postIndex }}
                </span>
                <template v-if="history.type === isRemovedFromPostPackage">
                  <v-icon v-tooltip="'Информация о досыле'" @click="loadInformation(history.mailSendHistory.Id)" v-if="history.mailSendHistory !== null" color="primary" class="ml-1">mdi-information-outline</v-icon>
                  <v-dialog
                      max-width="500px"
                      v-model="dialog"
                  >
                    <v-card>
                      <v-card-text style="padding: 10px; text-align: center; font-size: 20px">
                        Информация о досыле
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-text style="padding: 30px 30px 0 30px">
                        <span style="color: #1e4d99">Отправитель: </span>
                        {{ mailSendHistory.SendedFrom }}
                      </v-card-text>
                      <v-card-text style="padding: 0 30px 30px 30px">
                        <span style="color: #1e4d99">Получатель: </span>
                        {{ mailSendHistory.SendedTo }}
                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="primary" block @click="dialog = false">Закрыть</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </template>
              </b>
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider/>
      <v-card-text  v-if="isAllowSawPdf">
        <object width="100%" height="1200px" type="application/pdf" :data="pdfObjectData">
          <p>Пожалуйста обновите пожалуйста браузер</p>
        </object>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import MailService from "@/services/mail.service"
import Mappers from "@/mappers"
import PrintJS from "print-js";
import {  APP_MAIL_PERFORMED, APP_MAIL_UNSET_POST_PACKAGE, APP_MAIL_PERFORM_DELETED} from "@/events/app";
import _ from "underscore"
import {Performed, RemoveFromPostPackage} from "@/enums/history.type"
import {AllowDeleteFromPostPackage, AllowDeletePerform} from "@/enums/permission";
import PerformButtons from "@/components/mail/perform/PerformButtons";
import mailHistory from "@/domain/MailHistory";


export default {
  name: "MailView",
  components: {
    PerformButtons
  },
  data() {
    return {
      mail: null,
      histories: [],
      loading: false,
      dialog: false,
      mailSendHistory: {},
      deliveredDialog: false,
      failedDialog: false,
      tryPerformDialog: false,
      unsetPostPackageDialog: false,
      deletePerformDialog: false,

      performedHistoryType: Performed,
      isRemovedFromPostPackage: RemoveFromPostPackage
    }
  },
  computed: {
    isAllowUpdateStatusPerform() {
      const createdDate = new Date(this.mail.createdOn);
      const currentDate = new Date();
      const timeDiff = currentDate - createdDate;
      const daysDiff = timeDiff / (1000 * 60 * 60 * 24);

      return !this.mail.isPerformed && daysDiff >= 4;
    },
    isAllowSawPdf() {
      if (this.mail.isPerformed && [11, 10, 29, 1, 2209].includes(this.$store.getters.appLogin.id)) {
        return true;
      }
      else if(!this.mail.isPerformed){
        return true;
      }
      return false;
    },
    mailHistory() {
      return mailHistory
    },
    pageTitle() {
      let title = "Письмо"
      if (this.mail)
        title = `${title}: ${this.mail.uid} | ${this.mail.region.name} | ${this.mail.area.name}`

      return title
    },
    isMailLoaded() {
      return this.mail !== null
    },
    pdfObjectData() {
      return this.isMailLoaded ? `${MailService.getPdfPath(this.mail)}?#zoom=100` : ""
    },
    isAllowUnsetPostPackageMail() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowDeleteFromPostPackage
      })
    },
    isAllowDeletePerform() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowDeletePerform
      })
    }
  },
  methods: {
    updateStatus(){
      MailService.updateMailStatus(this.mail.uid)
          .then(response => {
            console.log(response)
            this.loadMail()
          })
          .catch(error => {
            console.error("Error fetching data:", error);
            this.$store.dispatch(LAYOUT_LOADING_STOP);
            this.loading = false;
          });
    },
    getMailPostCode(){
      return this.mail.postIndex ? this.mail.postIndex.postCode : null
    },
    convertDateStringToDateTime(dateString) {
      return new Date(dateString);
    },
    formatDate(date) {
      if (date instanceof Date && !isNaN(date)) {
        return date.toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" });
      } else {
        return "Invalid Date";
      }
    },
    loadInformation(id){
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      MailService.getSendHistory(id)
          .then(response => {
            this.mailSendHistory = response.data
          })
          .catch(() => {
            this.$router.push({name: "dashboard"})
          })
          .finally(() => {
            this.loading = false;
            this.dialog = true;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    setPageTitle() {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.pageTitle)
    },
    loadMail() {
      this.deliveredDialog = false
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      this.mail = null
      const uid = this.$route.params.uid
      MailService.get(uid)
          .then(response => {
            this.mail = Mappers.mapMail(response.data)

            this.setPageTitle()
            this.loadHistories();
          })
          .catch(() => {
            this.$router.push({name: "dashboard"})
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadHistories() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      MailService.getHistories(this.mail.uid)
          .then(response => {
            this.histories = _.map(response.data, mailHistoryViewModel => {
              return Mappers.mapMailHistory(mailHistoryViewModel)
            })
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onReprintButtonClicked() {
      const path = MailService.getPdfPath(this.mail)
      PrintJS({
        printable: path,
        type: "pdf",
        showModal: true,
        modalMessage: "Подождите, идет загрузка для печати"
      })
    },

    onMailPerformed() {
      this.$refs.successDeliveredPerform && this.$refs.successDeliveredPerform.clear()
      this.$refs.failedDeliveredPerform && this.$refs.failedDeliveredPerform.clear()
      this.$refs.tryPerform && this.$refs.tryPerform.clear()

      this.$nextTick(() => {
        this.deliveredDialog = false
        this.failedDialog = false
        this.tryPerformDialog = false
      })

      this.loadMail()
    },
    onUnsetPostPackage() {
      this.unsetPostPackageDialog = false
      this.loadMail()
    },
    onDeletePerformClicked() {
      this.loadMail()
    }
  },
  created() {
    this.$bus.$on(APP_MAIL_PERFORMED, this.onMailPerformed)
    this.$bus.$on(APP_MAIL_UNSET_POST_PACKAGE, this.onUnsetPostPackage)
    this.$bus.$on(APP_MAIL_PERFORM_DELETED, this.onDeletePerformClicked)

    this.setPageTitle()
    this.loadMail()
  },
  beforeDestroy() {
    this.$bus.$off(APP_MAIL_PERFORMED, this.onMailPerformed)
    this.$bus.$off(APP_MAIL_UNSET_POST_PACKAGE, this.onUnsetPostPackage)
    this.$bus.$on(APP_MAIL_PERFORM_DELETED, this.onDeletePerformClicked)
  },
  watch: {
    "$route": function () {
      this.loadMail()
    }
  }
}
</script>

<style scoped>

</style>
